import React, { Component } from "react";
import ReactToPrint from 'react-to-print';


import ObservationLotReport from "./Reports/ObservationLotReport";
import ObservationStandardReport from "./Reports/ObservationStandardReport";
import ObservationGenericReport2 from "./Reports/ObservationGenericReport2";




export default class SharedReportNavigatorPage extends Component 
{
    constructor(props) 
    {
        super(props);
        //this.configService = new ConfigService();
        this.state = 
        {

        }

    }


    async componentDidMount()
    {
        console.log("Mounting Shared Report Navigator.");
    }


    render()
    {

        var rptName = this.props.location?.state?.reportName?.toLowerCase() ?? "observation";
        var rpt;
        if (rptName === "observation-lot")
        {
            rpt =  <ObservationLotReport
            ref={(response) => (this.componentRef = response)} 
            onErrorPageRequest={this.props.onErrorPageRequest}
            onLoginExpire={this.props.onRequestLogout}
            onToastRequest={this.props.onToastRequest}
            userSession={this.props.userSession}
            onExpiredToken={this.props.onExpiredToken}

            observation={this.props.location?.state?.observation}
            observationId={this.props.location?.state?.observation?.identifiers?.id}
            reportName={this.props.location?.state?.reportName}
            shared={true}
            
          />
        } else if (rptName === "observation-std")
        {
            rpt = <ObservationStandardReport

            ref={(response) => (this.componentRef = response)} 

            onErrorPageRequest={this.props.onErrorPageRequest}
            onLoginExpire={this.props.onRequestLogout}
            onToastRequest={this.props.onToastRequest}
            userSession={this.props.userSession}
            onExpiredToken={this.props.onExpiredToken}

            observation={this.props.location?.state?.observation}
            observationId={this.props.location?.state?.observation?.identifiers?.id}
            reportName={this.props.location?.state?.reportName}
            shared={true}
        />
        }
        else 
        {
            rpt =  <ObservationGenericReport2

            ref={(response) => (this.componentRef = response)} 

            onErrorPageRequest={this.props.onErrorPageRequest}
            onLoginExpire={this.props.onRequestLogout}
            onToastRequest={this.props.onToastRequest}
            userSession={this.props.userSession}
            onExpiredToken={this.props.onExpiredToken}

            observation={this.props.location?.state?.observation}
            observationId={this.props.location?.state?.observation?.identifiers?.id}
            reportName={this.props.location?.state?.reportName}
            shared={true}
        />
        }




        return (
            <span>
       
                <ReactToPrint
                    trigger = {() => <button className="btn btn-primary">Print</button>}
                    content = {()=>this.componentRef}
                />

                {rpt}


            </span>

        )
    }





}